import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/api";

const TransferPoints = () => {
  const navigate = useNavigate();
  const [leaderboard, setLeaderboard] = useState({
    top_clubs: [],
    top_agency: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await api.get("/users/tp-leader-board/");
        console.log(response.data, "leaderboard");
        if (response.data) {
          setLeaderboard({
            top_clubs: response.data.top_clubs || [],
            top_agency: response.data.top_agency || [],
          });
        }
      } catch (error) {
        console.error("Failed to fetch leaderboard:", error);
        setError("Failed to load leaderboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  const handleClubClick = (clubId) => {
    navigate(`/search/club/${clubId}`);
  };

  const handleAgencyClick = (agencyId) => {
    navigate(`/search/agency/${agencyId}`);
  };

  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-8 mt-8">
        <div className="animate-pulse bg-white rounded-lg h-64" />
        <div className="animate-pulse bg-white rounded-lg h-64" />
      </div>
    );
  }

  if (error) {
    return <div className="mt-8 text-center text-red-500">{error}</div>;
  }

  const getRankingStyle = (rank) => {
    switch (rank) {
      case 1:
        return {
          background: "#FFDE78",
          border: "4px solid transparent",
          backgroundImage: `
            linear-gradient(#FFDE78, #FFDE78),
            linear-gradient(142.35deg, #8C421D 22.68%, #FBE67B 42.5%, #FCFBE7 55.31%, #F7D14E 69.6%, #D4A041 83.62%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      case 2:
        return {
          background: "#F1F6FA",
          border: "3.5px solid transparent",
          backgroundImage: `
            linear-gradient(#F1F6FA, #F1F6FA),
            linear-gradient(137.95deg, #7A96AC 2.28%, #EAEFF3 19.8%, #C2D4E1 32.94%, #FFFFFF 50.16%, #D4DEE5 62.15%, #ABBDC8 78.69%, #BCCAD7 95.24%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      case 3:
        return {
          background: "#E5BE96",
          border: "4px solid transparent",
          backgroundImage: `
            linear-gradient(#E5BE96, #E5BE96),
            linear-gradient(153.43deg, #9E8976 7.68%, #7A5E50 24.01%, #F6D0AB 42.02%, #9D774E 58.77%, #C99B70 79.3%, #795F52 91.44%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      default:
        return {
          background: "#1A212F33",
          color: "#222A35",
        };
    }
  };

  const getTransferPointsStyle = (rank) => {
    switch (rank) {
      case 1:
        return {
          background:
            "linear-gradient(115.37deg, #8C421D -4.56%, #FBE67B 25.26%, #FCFBE7 44.54%, #F7D14E 66.03%, #D4A041 87.13%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(115.37deg, #8C421D -4.56%, #FBE67B 25.26%, #FCFBE7 44.54%, #F7D14E 66.03%, #D4A041 87.13%),
            linear-gradient(180deg, #CA9E52 0%, #F3E184 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#A37021",
        };
      case 2:
        return {
          background:
            "linear-gradient(140.73deg, #7A96AC -1.47%, #EAEFF3 17.4%, #C2D4E1 31.55%, #FFFFFF 50.09%, #D4DEE5 62.99%, #ABBDC8 80.81%, #BCCAD7 98.62%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(140.73deg, #7A96AC -1.47%, #EAEFF3 17.4%, #C2D4E1 31.55%, #FFFFFF 50.09%, #D4DEE5 62.99%, #ABBDC8 80.81%, #BCCAD7 98.62%),
            linear-gradient(180deg, #B8CADA 0%, #9BACB6 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#5B5B5B",
        };
      case 3:
        return {
          background:
            "linear-gradient(138.64deg, #9E8976 1.58%, #7A5E50 13.18%, #F6D0AB 48.26%, #9D774E 71.03%, #C99B70 98.92%, #795F52 115.43%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(138.64deg, #9E8976 1.58%, #7A5E50 13.18%, #F6D0AB 48.26%, #9D774E 71.03%, #C99B70 98.92%, #795F52 115.43%),
            linear-gradient(180deg, #F6D0AB 0%, #7B5F51 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#614B3F",
        };
      default:
        return {
          background: "#1A212F",
          color: "white",
        };
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
      {/* Top Clubs */}
      <div className="bg-white border border-[#D6DBEA] rounded-lg p-4 shadow-sm">
        <div className="flex justify-between items-center mb-8">
          <h3 className="text-base font-bold">Top Clubs</h3>
          <Link
            to="/leaderboard?type=clubs"
            className="text-xs text-[#2283FF] hover:text-blue-700"
          >
            View Leaderboard
          </Link>
        </div>

        {/* Table Headers - Desktop only */}
        <div className="hidden md:grid grid-cols-4 gap-2 mb-3 border-b border-[#E5E7EB] pb-2">
          <div className="text-[#1A212FB2] text-xs font-medium">Rank</div>
          <div className="text-[#1A212FB2] text-xs font-medium">Club name</div>
          <div className="text-[#1A212FB2] text-xs font-medium">Requests</div>
          <div className="text-[#1A212FB2] text-xs font-medium">
            Transfer Points
          </div>
        </div>

        {/* Mobile Table Headers */}
        <div className="md:hidden flex items-center pb-2 border-b border-[#E5E7EB] text-xs font-medium text-[#1A212FB2]">
          <span className="w-3/5">Club</span>
          <span className="w-1/5 text-center">Requests</span>
          <span className="w-1/5 text-right">Points</span>
        </div>

        {/* Table Rows / Mobile Cards */}
        <div className="space-y-2">
          {leaderboard.top_clubs.map((club, index) => (
            <div key={club.club_id}>
              {/* Desktop view */}
              <div className="hidden md:grid grid-cols-4 gap-2 items-center py-2 border-b border-[#D6DBEA]">
                {/* Ranking */}
                <div
                  className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                  style={getRankingStyle(index + 1)}
                >
                  {index + 1}
                </div>

                {/* Club Name */}
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={() => handleClubClick(club.club_id)}
                >
                  {club.club_logo ? (
                    <img
                      src={club.club_logo}
                      alt={club.club_name}
                      className="w-5 h-5 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center">
                      <span className="text-xs text-secondary">
                        {club.club_name.slice(0, 2).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <span className="text-[#222A35] text-xs font-medium truncate">
                    {club.club_name}
                  </span>
                </div>

                {/* Tenders Completed */}
                <div className="text-[#1A212F] text-xs font-medium">
                  {club.tenders_completed || 0}
                </div>

                {/* Transfer Points */}
                <div
                  className="text-center py-1 rounded-full text-xs font-bold"
                  style={getTransferPointsStyle(index + 1)}
                >
                  {club.tp_balance.toLocaleString()}
                </div>
              </div>

              {/* Mobile view - Single Row */}
              <div className="md:hidden flex items-center py-2 border-b border-[#D6DBEA] text-xs">
                <div
                  className="w-3/5 flex items-center gap-2 min-w-0 cursor-pointer"
                  onClick={() => handleClubClick(club.club_id)}
                >
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center font-bold flex-shrink-0"
                    style={getRankingStyle(index + 1)}
                  >
                    {index + 1}
                  </div>
                  {club.club_logo ? (
                    <img
                      src={club.club_logo}
                      alt={club.club_name}
                      className="w-5 h-5 rounded-full object-cover flex-shrink-0"
                    />
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                      <span className="text-secondary">
                        {club.club_name.slice(0, 2).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <p className="text-[#222A35] font-medium truncate flex-1">
                    {club.club_name}
                  </p>
                </div>
                <div className="w-1/5 text-center font-medium text-[#1A212F]">
                  {club.tenders_completed || 0}
                </div>
                <div className="w-1/5 text-right">
                  <div
                    className="inline-block text-center py-1 px-2 rounded-full font-bold"
                    style={getTransferPointsStyle(index + 1)}
                  >
                    {club.tp_balance.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Top Agents */}
      <div className="bg-white shadow-sm border border-[#D6DBEA] rounded-lg p-4">
        <div className="flex justify-between items-center mb-8">
          <h3 className="text-base font-bold">Top Agents</h3>
          <Link
            to="/leaderboard?type=agents"
            className="text-xs text-[#2283FF] hover:text-blue-700"
          >
            View Leaderboard
          </Link>
        </div>

        {/* Table Headers - Desktop only */}
        <div className="hidden md:grid grid-cols-4 gap-2 mb-3 border-b border-[#E5E7EB] pb-2">
          <div className="text-[#1A212FB2] text-xs font-medium">Rank</div>
          <div className="text-[#1A212FB2] text-xs font-medium">
            Agency name
          </div>
          <div className="text-[#1A212FB2] text-xs font-medium">Pitches</div>
          <div className="text-[#1A212FB2] text-xs font-medium">
            Transfer Points
          </div>
        </div>

        {/* Mobile Table Headers */}
        <div className="md:hidden flex items-center pb-2 border-b border-[#E5E7EB] text-xs font-medium text-[#1A212FB2]">
          <span className="w-3/5">Agency</span>
          <span className="w-1/5 text-center">Pitches</span>
          <span className="w-1/5 text-right">Points</span>
        </div>

        {/* Table Rows / Mobile Cards */}
        <div className="space-y-2">
          {leaderboard.top_agency.map((agency, index) => (
            <div key={agency.agency_id}>
              {/* Desktop view */}
              <div className="hidden md:grid grid-cols-4 gap-2 items-center py-2 border-b border-[#D6DBEA]">
                {/* Ranking */}
                <div
                  className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                  style={getRankingStyle(index + 1)}
                >
                  {index + 1}
                </div>

                {/* Agency Name */}
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={() => handleAgencyClick(agency.agency_id)}
                >
                  <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center">
                    {agency.profile_picture_url ? (
                      <img
                        src={agency.profile_picture_url}
                        alt={agency.agency_name}
                        className="w-5 h-5 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center">
                        <span className="text-xs text-secondary">
                          {agency.agency_name.slice(0, 2).toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>
                  <span className="text-[#222A35] text-xs font-medium truncate">
                    {agency.agency_name}
                  </span>
                </div>

                {/* Pitches Completed */}
                <div className="text-[#1A212F] text-xs font-medium">
                  {agency.pitches_completed || 0}
                </div>

                {/* Transfer Points */}
                <div
                  className="text-center py-1 rounded-full text-xs font-bold"
                  style={getTransferPointsStyle(index + 1)}
                >
                  {agency.tp_balance.toLocaleString()}
                </div>
              </div>

              {/* Mobile view - Single Row */}
              <div className="md:hidden flex items-center py-2 border-b border-[#D6DBEA] text-xs">
                <div
                  className="w-3/5 flex items-center gap-2 min-w-0 cursor-pointer"
                  onClick={() => handleAgencyClick(agency.agency_id)}
                >
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center font-bold flex-shrink-0"
                    style={getRankingStyle(index + 1)}
                  >
                    {index + 1}
                  </div>
                  {agency.profile_picture_url ? (
                    <img
                      src={agency.profile_picture_url}
                      alt={agency.agency_name}
                      className="w-5 h-5 rounded-full object-cover flex-shrink-0"
                    />
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                      <span className="text-secondary">
                        {agency.agency_name.slice(0, 2).toUpperCase()}
                      </span>
                    </div>
                  )}
                  <p className="text-[#222A35] font-medium truncate flex-1">
                    {agency.agency_name}
                  </p>
                </div>
                <div className="w-1/5 text-center font-medium text-[#1A212F]">
                  {agency.pitches_completed || 0}
                </div>
                <div className="w-1/5 text-right">
                  <div
                    className="inline-block text-center py-1 px-2 rounded-full font-bold"
                    style={getTransferPointsStyle(index + 1)}
                  >
                    {agency.tp_balance.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransferPoints;
